// src/theme/components/divider.js
// Sade, semantic token tabanli. 3 variant: solid (default), subtle, accent.

const Divider = {
  baseStyle: {
    borderColor: 'borderPrimary',
    opacity: 1,
  },
  variants: {
    solid: {
      borderColor: 'borderPrimary',
    },
    subtle: {
      borderColor: 'borderSecondary',
      opacity: 0.6,
    },
    accent: {
      borderColor: 'accent',
      opacity: 0.5,
    },
    dashed: {
      borderColor: 'borderPrimary',
      borderStyle: 'dashed',
    },
  },
  defaultProps: {
    variant: 'solid',
  },
};

export default Divider;
